import { BoardPurchaseCascadableInterface } from '../interfaces/board-purchase-cascadable.interface';
import { BoardPurchaseDto } from './board-purchase.dto';
import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { Validate, ValidateNested } from 'class-validator';
import { BoardFloorUniqueValidator } from '../../board-floor/validators/board-floor-unique.validator';
import { BoardPurchaseFloorCascadeDto } from '../../board-purchase-floor/dto/board-purchase-floor-cascade.dto';

export class BoardPurchaseCascadeDto
  extends IntersectionType(
    PickType(BoardPurchaseDto, ['orderNumber', 'dateExpected', 'supplierId']),
    PartialType(
      PickType(BoardPurchaseDto, [
        'laborOnly',
        'isReplacement',
        'approved',
        'approvedGeo',
      ]),
    ),
  )
  implements BoardPurchaseCascadableInterface
{
  @ApiPropertyOptional({
    type: () => [BoardPurchaseFloorCascadeDto],
    title: 'Associated Board Purchase Floors',
    description: 'The board purchase floors associated with this job',
  })
  @Expose()
  @Type(() => BoardPurchaseFloorCascadeDto)
  @Validate(BoardFloorUniqueValidator)
  @ValidateNested({ each: true })
  boardPurchaseFloors!: BoardPurchaseFloorCascadeDto[];
}
